import {  UserData , MajorTopic, ChatMessage, ResponseMetric} from '../../types/usageMetrics';
import { format, subDays } from 'date-fns';
// api.ts or wherever your API functions are defined

export const fetchTokenUsageByModel = async (
    app_id: string,
    startDate: string,
    endDate: string
  ) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usage-metrics/token-usage-by-model`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      date_range: {
        from_date: startDate,
        to_date: endDate,
      },
      app_id
    }),
  });
  const data = await response.json();
  if (data?.detail) {
      return [];
  }
  return data? data : [];
  };
  type TokenUsageUser = {
    username: string;
    tokensUsed: number;
  };
  export async function fetchTokenUsageByUsers(app_id: string): Promise<TokenUsageUser[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          { username: "alex_developer", tokensUsed: 1430000 },
          { username: "maria_ml", tokensUsed: 2150000},
          { username: "data_science_team", tokensUsed: 3800000},
          { username: "support_bot", tokensUsed: 5240000},
          { username: "content_creator", tokensUsed: 950000 },
          { username: "research_group", tokensUsed: 1850000 },
          { username: "qa_automated", tokensUsed: 720000},
        ]);
      }, 500); // Simulates API response delay
    });
  }
  

  export async function fetchTopUsers(app_id: string,startDate: string,endDate: string): Promise<UserData[]> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usage-metrics/top-active-user`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      app_id,
      from_date: startDate,
      to_date: endDate,
    }),
  });
  const data = await response.json();
   if (data?.detail) {
      return [];
  }
  return data? data : [];
  }

  
  export async function fetchChatByDate(app_id: string, date: string): Promise<ChatMessage[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          { id: "12", chat_id: '122', content: 'test',sender:'user',app_id:'ddd' },
          { id: "12", chat_id: '122', content: 'test2',sender:'assistant',app_id:'ddd' },
          { id: "12", chat_id: '122', content: 'test3',sender:'user',app_id:'ddd' },
          { id: "12", chat_id: '122', content: 'test4',sender:'assistant',app_id:'ddd' },
          { id: "12", chat_id: '122', content: 'test5',sender:'user',app_id:'ddd' },
          { id: "12", chat_id: '122', content: 'test6',sender:'assistant',app_id:'ddd' },
        ]);
      }, 500); // Simulates API response delay
    });
  }
  
  export async function fetchMajorTopicDiscussed(app_id: string): Promise<MajorTopic[]> {
    const url = `${process.env.REACT_APP_API_URL}/api/usage-metrics/top-titles`;

    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ app_id }),
    });
    const data = await response.json();
    if (data?.detail) {
      return [];
    }
    return Array.isArray(data) ? data.slice(0, 5) : [];
  }

  export async function fetchResponseTimeDetail(app_id: string,endDate: string,
    range: '7d' | '30d' | '90d'): Promise<ResponseMetric[]> {
    // console.log("Fetching token usage for app_id:", app_id);
    return generateMockMetricsData(endDate, range);
   
  }
  function generateMockMetricsData(
    endDateStr: string,
    range: '7d' | '30d' | '90d'
  ): ResponseMetric[] {
    const data: ResponseMetric[] = [];
    const endDate = new Date(endDateStr);
    
    // Determine number of days based on range
    let days = 7;
    if (range === '30d') days = 30;
    if (range === '90d') days = 90;
    
    // Generate data for each day
    for (let i = days - 1; i >= 0; i--) {
      const date = subDays(endDate, i);
      const shortDate = `${date.getMonth() + 1}/${date.getDate()}`;
      
      // Create somewhat realistic looking data with some randomness
      // Use seeds based on the date to ensure consistent "random" values for same dates
      const dateSeed = date.getDate() + (date.getMonth() * 100);
      
      // Generate pseudo-random values using the date as a seed
      // This ensures consistent values for the same date
      const avgResponseTime = 1.5 + (Math.sin(dateSeed * 0.1) + 1) * 1.25;
      const errorCount = Math.floor(Math.abs(Math.cos(dateSeed * 0.3) * 8));
      const outOfContextCount = Math.floor(Math.abs(Math.sin(dateSeed * 0.5) * 5));
      
      data.push({
        date: date.toLocaleDateString(),
        fullDate: date.toLocaleDateString(),
        avgResponseTime,
        errorCount,
        outOfContextCount
      });
    }
    
    return data;
  }